import React, { useState } from 'react';
import type { ProductDto } from '../types/product';
import { useDeleteProduct } from '../hooks/useProductMutations';
import '../styles/Modal.css';

interface DeleteProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: ProductDto | null;
}

export function DeleteProductModal({
  isOpen,
  onClose,
  product,
}: DeleteProductModalProps): JSX.Element | null {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const deleteMutation = useDeleteProduct();

  if (!isOpen || !product) return null;

  async function handleConfirm(): Promise<void> {
    if (!product) return;
    setErrorMessage(null);
    try {
      await deleteMutation.mutateAsync(product.id);
      onClose();
    } catch (err) {
      setErrorMessage(err instanceof Error ? err.message : 'מחיקה נכשלה');
    }
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-box modal-box--confirm" dir="rtl">
        <h2 className="modal-title">מחיקת מוצר</h2>
        {errorMessage && (
          <div className="api-error-message">{errorMessage}</div>
        )}
        <p className="confirm-message">
          האם אתה בטוח שברצונך למחוק את המוצר{' '}
          <strong>&ldquo;{product.nameHebrew}&rdquo;</strong>? פעולה זו אינה
          הפיכה.
        </p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={deleteMutation.isPending}
          >
            ביטול
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={handleConfirm}
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? 'מוחק...' : 'מחק'}
          </button>
        </div>
      </div>
    </div>
  );
}
